var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8742 20.1668C18.8742 16.6193 15.345 13.7502 11 13.7502C6.65499 13.7502 3.12582 16.6193 3.12582 20.1668M11 11.0002C12.2156 11.0002 13.3814 10.5173 14.2409 9.65774C15.1004 8.79819 15.5833 7.63241 15.5833 6.41683C15.5833 5.20125 15.1004 4.03547 14.2409 3.17592C13.3814 2.31638 12.2156 1.8335 11 1.8335C9.78442 1.8335 8.61863 2.31638 7.75908 3.17592C6.89954 4.03547 6.41666 5.20125 6.41666 6.41683C6.41666 7.63241 6.89954 8.79819 7.75908 9.65774C8.61863 10.5173 9.78442 11.0002 11 11.0002Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.499c9ab3d3dc2273f440da14471df940.svg";
export { ForwardRef as ReactComponent };